<template>
  <div class="mc">
    <!-- <Header class="header" zai="true">
      <router-link slot="right" to="/share">分享</router-link>
    </Header> -->
    <div class="head">
      <div class="user-log">
        <div class="mc-name">{{ user.username }}</div>
        <router-link to="/account" class="mc-information">
          <img :src="user.avatarurl || heada" class="head-img" alt="" />
        </router-link>
      </div>
      <div class="bar-info">
        <router-link to="/myshare/friend" class="eve-list">
          <img src="@/assets/image/user-menber.png" alt="" />
          <div><strong>发展会员</strong></div>
          <div>{{ user.share_num }}人</div>
        </router-link>
        <router-link to="/money" class="eve-list">
          <img src="@/assets/image/user-balance.png" alt="" />
          <div><strong>奖金总额</strong></div>
          <div>￥{{ user.award_count }}</div>
        </router-link>
      </div>
      <!-- <div class="mc-mobile">{{user.mobile}}</div> -->
    </div>
    <div class="mc-list">
      <router-link to="/userinfo" class="eve-list">
        <div class="chooes-list">
          <img src="@/assets/image/user-info.png" class="eveimg" alt="" />
          <div>个人资料</div>
        </div>
      </router-link>

      <!-- <router-link to="/money" class="eve-list">
        <div class="chooes-list">
          <img src="@/assets/image/mone.png" class="eveimg" alt="">
          <div>我的奖金</div>
        </div>
      </router-link>
      <router-link to="/personal" class="eve-list">
        <div class="chooes-list">
          <img src="@/assets/image/grouping.png" class="eveimg" alt="">
          <div>收款信息</div>
        </div>
      </router-link> -->
      <!-- <router-link to="/public" class="eve-list" v-if="user.is_working == 1">
        <div class="chooes-list">
          <img src="@/assets/image/user-public.png" class="eveimg" alt="">
          <div>我的发布</div>
        </div>
      </router-link> -->
      <router-link to="/share" class="eve-list">
        <div class="chooes-list">
          <img src="@/assets/image/user-share.png" class="eveimg" alt="" />
          <div>我的分享</div>
        </div>
      </router-link>
      <router-link to="/lookData" class="eve-list">
        <div class="chooes-list">
          <img src="@/assets/image/lookData.png" class="eveimg" alt="" />
          <div>数据查看</div>
        </div>
      </router-link>
      <router-link to="/retrievePassword?type=1" class="eve-list">
        <div class="chooes-list">
          <img src="@/assets/image/setPassworf.png" class="eveimg" alt="" />
          <div>密码设置</div>
        </div>
      </router-link>
      <router-link to="/login" class="eve-list">
        <div class="chooes-list">
          <img src="@/assets/image/user-logout.png" class="eveimg" alt="" />
          <div>退出登录</div>
        </div>
      </router-link>
    </div>
    <div class="share-men" v-if="user.share_uname">
      <p>推荐人：</p>
      <p>{{ user.share_uname }}</p>
    </div>
  </div>
</template>

<script>
import { getUserInfo } from "@/api/api/user";
// import Header from '@/components/header.vue'
const defaultAvatar = require("@/assets/image/head.jpg");

export default {
  data() {
    return {
      wechat: "",
      user: {},
      heada: defaultAvatar,
    };
  },
  created() {
    this.getUser();
  },
  components: {
    // Header
  },
  methods: {
    getUser() {
      getUserInfo().then((res) => {
        this.user = res.data.data;
        this.user.avatarurl =
          this.user.avatarurl + "?n=" + Math.floor(Math.random() * 100);
        window.localStorage.setItem("phone", res.data.data.mobile);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.mc {
  padding: 0 12px;
  padding-top: 44px;
  padding-bottom: 84px;
  min-height: 100%;
  background: url("~@/assets/image/back-water.png");
  background-color: #f0f0f0;
  background-size: 100% 205px;
  background-repeat: no-repeat;
  .header {
    margin: 0 -12px;
    background: none;
  }
  .share-men {
    justify-content: center;
    color: #ccc;
    display: flex;
  }
  .mc-list {
    margin-top: 12px;
    min-height: 30vh;
    background: #ffffff;
    box-shadow: 0px -1px 14px 0px rgba(103, 163, 233, 0.5);
    border-radius: 8px;
    padding: 10px 15px;
    .eve-list {
      display: flex;
      font-size: 15px;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #d8d8d8;
      width: 100%;
      height: 45px;
      padding: 0 10px 0 10px;
      color: black;
      .chooes-list {
        height: 100%;
        display: flex;
        align-items: center;
      }
    }
  }

  .head {
    background: #ffffff;
    box-shadow: 0px -1px 14px 0px rgba(103, 163, 233, 0.5);
    border-radius: 8px;
    padding: 0 15px;
    text-align: center;
    margin-top: 70px;
    height: 140px;
    position: relative;
    padding-top: 70px;
    .bar-info {
      display: flex;
      justify-content: space-around;
      align-items: center;
      img {
        width: 24px;
        height: 24px;
      }
      div {
        padding-bottom: 4px;
      }
    }
    .user-log {
      position: absolute;
      top: -64px;
      left: 0;
      right: 0;
      margin: 0 auto;
      border-bottom: 1px solid #ccc;
      padding-bottom: 10px;
    }
    .mc-mobile {
      color: #c4c0d9;
      padding-top: 10px;
    }
    .mc-name {
      padding-bottom: 19px;
      color: white;
      font-size: 19px;
    }
    .head-img {
      width: 73px;
      height: 73px;
      border-radius: 7px;
    }
  }
  .right-cli {
    width: 8px;
    height: 14px;
  }
  .eveimg {
    width: 30px;
    height: 30px;
    margin-right: 20px;
  }
  .oneimg {
    width: 30px;
    height: 30px;
    margin-right: 20px;
  }
}
</style>
